import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5be13148"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "columns small-12" }, [
        /*#__PURE__*/ _createElementVNode("label", null, "Socket Configuration")
    ])
], -1 /* HOISTED */));
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "columns small-12" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Component Type", -1 /* HOISTED */));
import { useSocketFilterType } from "./useSocketFilterType";
import DropdownSelectorInput from "src/shared/v-components/ui/form/DropdownSelectorInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SocketVariableMutableFields',
    props: {
        componentMutable: {}
    },
    setup(__props) {
        const props = __props;
        const { filterType, componentTypeOptions } = useSocketFilterType(() => props.componentMutable);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createVNode(DropdownSelectorInput, {
                            modelValue: _unref(filterType),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(filterType) ? (filterType).value = $event : null)),
                            options: _unref(componentTypeOptions),
                            prompt: "Select component type"
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
